<template>
    <header class="header-global">
        <base-nav class="navbar-main" transparent type="" effect="light" expand>
            <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
                <img src="img/consultoria/ptLetras2.0.png" alt="logo">
            </router-link>

            <div class="row" slot="content-header" slot-scope="{closeMenu}">
                <div class="col-6 collapse-brand">
                    <img src="img/consultoria/ptLetras2.0.png" alt="logo">
                </div>
                <div class="col-6 collapse-close">
                    <close-button @click="closeMenu"></close-button>
                </div>
            </div>

            <ul class="navbar-nav align-items-lg-center ml-lg-auto">
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="https://www.facebook.com/creativetim" target="_blank"
                        rel="noopener" data-toggle="tooltip" title="Link de Facebook">
                        <i class="fa fa-facebook-square fa-2x" style="color: #3b5998; "></i>
                        <span class="nav-link-inner--text d-lg-none">Facebook</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="https://www.instagram.com/creativetimofficial"
                        target="_blank" rel="noopener" data-toggle="tooltip" title="Link Instagram">
                        <i class="fa fa-instagram fa-2x"
                            style="background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent;"></i>
                        <span class="nav-link-inner--text d-lg-none">Instagram</span>
                    </a>
                </li>


            </ul>
        </base-nav>
    </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
    components: {
        BaseNav,
        CloseButton,
        BaseDropdown
    }
};
</script>
<style>
/* ===== ESTILOS SOLO PARA MÓVILES ===== */
@media (max-width: 991.98px) {
    .navbar-main .navbar-collapse {
        background: linear-gradient(135deg, #2C4A36 0%, #3D6B47 50%, #5C8467 100%) !important;
        border: 1px solid #e6ece1 !important;
        border-radius: 12px !important;
        padding: 20px 15px !important;
        box-shadow: 0 15px 40px rgba(44, 74, 54, 0.3) !important;
        margin-top: 10px !important;
    }
}
</style>
